window.addEventListener( 'alpine:init', bootstrap );

export default () => ({
	init() {
		const $active_panel = this.getActivePanel();
		if ( $active_panel !== false ) { this.setContainerHeight($active_panel); }
	},
	getActivePanel() {
		const $active_panel = this.$root.querySelector('.vc_tta-panel.vc_active');
		if ( !$active_panel ) { return false; }

		return $active_panel;
	},
	setContainerHeight($panel) {
		this.$root.style.setProperty('--panel-height', $panel.clientHeight + 'px');
	},
	changeTab() {
		const $target = this.getLink(this.$event.target);
		if ( $target === false ) { return; }
		const href = $target.href;
		let target_id = (new URL(href)).hash;
		if ( target_id.substring(0, 1) === '#' ) {
			target_id = target_id.substring(1);
		}
		const $panel = document.getElementById(target_id);
		if ( $panel ) {
			this.$nextTick( () => this.setContainerHeight($panel) );
		}
	},
	getLink($el) {
		if ( $el.hasAttribute('x-on:click.prevent') ) {
			return $el;
		}

		return $el.parentNode ? this.getLink($el.parentNode) : false;
	}
});

function bootstrap() {
	document.querySelectorAll('.js-alpine-tabs')
		.forEach( $el => bootstrapTabs($el) )
	;
}

function bootstrapTabs($el) {
	$el.setAttribute('x-data', 'tabs');
	$el.classList.add('is-alpine-tabs');

	$el.querySelectorAll('.vc_tta-tab > a').forEach(
		$$ => bootstrapTabTrigger($$)
	);
}

function bootstrapTabTrigger($el) {
	$el.setAttribute('x-on:click.prevent', 'changeTab');
}

